<template>
  <a-modal
    :title="$t('page_material_add_customer')"
    :visible="visible"
    @cancel="close()"
    :confirmLoading="confirmLoading"
    @ok="save()"
  >
    <a-form :form="form" :label-col="{ span: 7 }" :wrapper-col="{ span: 14 }">
      <a-form-item :label="$t('page_system_coding_rules')">
        <a-select
          style="width: 100%"
          v-decorator="['codeRuleId']"
          :placeholder="$t('please_select') + $t('page_system_coding_rules')"
          @change="handleSelectChange"
          :allowClear="true"
          show-search
          :filter-option="filterOption"
        >
          <a-select-option
            :value="item.value"
            v-for="(item, index) in codeList"
            :key="index"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('page_material_customer_code')">
        <a-input
          :disabled="codeId"
          style="width: 100%"
          :placeholder="$t('common_please_input') + $t('page_material_customer_code')"
          v-decorator="[
            'code',
            {
              rules: [
                {
                  required: false,
                  max: 48,
                  message: $t('page_material_warehousing_custom_input48'),
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('page_material_customer_name')">
        <a-auto-complete
          :data-source="dataSource"
          style="width: 275px"
          @search="onSearchCustomer"
          :placeholder="$t('common_please_input') + $t('page_material_customer_name')"
          v-decorator="[
            'name',
            {
              rules: [
                {
                  required: true,
                  max: 48,
                  message: $t('page_material_warehousing_custom_input48'),
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('page_tenant_contacts')">
        <a-input v-decorator="['contact']" :placeholder="$t('common_please_input') + $t('page_tenant_contacts')" />
      </a-form-item>
      <a-form-item :label="$t('page_tenant_contact_number')">
        <a-input v-decorator="['tel']" :placeholder="$t('common_please_input') + $t('page_tenant_contact_number')" />
      </a-form-item>
      <a-form-item :label="$t('page_ops_customer_province')">
        <a-select
          :placeholder="$t('please_select') + $t('page_ops_customer_province')"
          show-search
          :filter-option="filterOption"
          v-decorator="[
            'provinceId',
            {
              rules: [{ required: true, message: $t('please_select') + $t('page_ops_customer_province') }],
            },
          ]"
          @change="handleProvinceChange"
        >
          <a-select-option
            :key="item.code"
            :value="item.code"
            v-for="item in provinceList"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('page_ops_customer_city')">
        <a-select
          :placeholder="$t('please_select') + $t('page_ops_customer_city')"
          show-search
          :filter-option="filterOption"
          v-decorator="[
            'cityId',
            {
              rules: [{ required: true, message: $t('please_select') + $t('page_ops_customer_city') }],
            },
          ]"
          @change="handleCityChange"
        >
          <a-select-option
            :key="item.code"
            :value="item.code"
            v-for="item in cityList"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('page_ops_customer_detailed_address')">
        <a-textarea
          :placeholder="$t('common_please_input') + $t('page_ops_customer_detailed_address')"
          v-decorator="[
            'address',
            {
              rules: [{ required: true, message: $t('common_please_input') + $t('page_ops_customer_detailed_address') }],
            },
          ]"
          :auto-size="{ minRows: 3, maxRows: 5 }"
        />
      </a-form-item>
      <a-form-item :label="$t('page_ops_customer_data_permissions')">
        <!-- tree-checkable -->
        <a-tree-select
          show-search
          tree-node-filter-prop="title"
          v-decorator="[
            'createDept',
            {
              rules: [{ required: true, message: $t('please_select') + $t('page_ops_customer_data_permissions') }],
            },
          ]"
          style="width: 100%"
          :tree-data="treeData"
          :multiple="false"
          :placeholder="$t('please_select') + $t('page_ops_customer_data_permissions')"
        />
      </a-form-item>
      <a-form-item :label="$t('page_material_more') + '1'">
        <a-input
          style="width: 100%"
          :placeholder="$t('common_please_input') + $t('page_material_more') + '1'"
          v-decorator="[
            'extend1',
            {
              rules: [
                {
                  max: 48,
                  message: $t('page_material_warehousing_custom_more48'),
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('page_material_more') + '2'">
        <a-input
          style="width: 100%"
          :placeholder="$t('common_please_input') + $t('page_material_more') + '2'"
          v-decorator="[
            'extend2',
            {
              rules: [
                {
                  max: 48,
                  message: $t('page_material_warehousing_custom_more48'),
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('page_material_more') + '3'">
        <a-input
          style="width: 100%"
          :placeholder="$t('common_please_input') + $t('page_material_more') + '3'"
          v-decorator="[
            'extend3',
            {
              rules: [
                {
                  max: 48,
                  message: $t('page_material_warehousing_custom_more48'),
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('page_material_more') + '4'">
        <a-input
          style="width: 100%"
          :placeholder="$t('common_please_input') + $t('page_material_more') + '4'"
          v-decorator="[
            'extend4',
            {
              rules: [
                {
                  max: 48,
                  message: $t('page_material_warehousing_custom_more48'),
                },
              ],
            },
          ]"
        />
      </a-form-item>
      <a-form-item :label="$t('page_material_more') + '5'">
        <a-input
          style="width: 100%"
          :placeholder="$t('common_please_input') + $t('page_material_more') + '5'"
          v-decorator="[
            'extend5',
            {
              rules: [
                {
                  max: 48,
                  message: $t('page_material_warehousing_custom_more48'),
                },
              ],
            },
          ]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { CodeRuleServiceProxy } from "@/service-proxies/app-v2/code.service-proxies";
import {
  AuthorityDomainServiceProxy,
  RegionServiceProxy,
} from "@/service-proxies/app-v2/system.service-proxies";
import { CustomerServiceProxy } from "@/service-proxies/app-v2/client.service-proxies";

const csp = new CustomerServiceProxy();
const crsp = new CodeRuleServiceProxy();
const adsp = new AuthorityDomainServiceProxy();
const rsp = new RegionServiceProxy();

import R from "ramda";

const resetProp = (from, to) => R.pipe(R.prop(from), R.objOf(to));

const tranformTreeShape = (data) => {
  const setLabel = resetProp("title", "label");
  const setValue = resetProp("id", "value");
  const setChildren = R.pipe(
    R.prop("children"),
    R.ifElse(
      R.either(R.isNil, R.isEmpty),
      R.empty,
      R.pipe(R.map(tranformTreeShape), R.objOf("children"))
    )
  );

  return R.converge(R.unapply(R.mergeAll), [setLabel, setValue, setChildren])(
    data
  );
};
let timeout;
let currentValue;

function fetchCustomers(value, callback) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;

  function getCustomers() {
    csp.getCustomers(value).then((result) => {
      if (currentValue === value) {
        const data = [];
        result.forEach((r) => {
          data.push(r["name"]);
        });
        callback(data);
      }
    });
  }

  timeout = setTimeout(getCustomers, 300);
}

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      confirmLoading: false,
      codeList: [],
      codeId: false,
      codeRuleId: "",
      cityValue: "",
      provinceList: [],
      cityList: [],
      treeData: [],
      dataSource: [],
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  async created() {
    await this.getAuthorityDomainList();
    this.provinceList = await this.getRegionList();
    this.getList();
  },
  watch: {
    visible: {
      handler(val) {
        if (val === true) {
          this.codeId = false;
        }
      },
    },
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    onSearchCustomer(searchText) {
      fetchCustomers(searchText, (data) => (this.dataSource = data));
    },
    close() {
      this.form.resetFields();
      this.$emit("close");
    },
    handleProvinceChange(value) {
      this.getCityList(value);
      if (this.cityValue) {
        this.form.setFieldsValue({
          cityId: "",
        });
      }
    },
    handleCityChange(value) {
      this.cityValue = value;
    },
    save() {
      this.form.validateFields((err, values) => {
        if (!err) {
          Object.keys(values).forEach((key) => {
            const str = values[key];
            if (str !== undefined) {
              values[key] = str.replace(/\s+/g, "");
            }
          });
          const data = { ...values };
          data.provinceName = this.provinceList.find(
            (res) => res.code === values.provinceId
          ).name;
          data.cityName = this.cityList.find(
            (res) => res.code === values.cityId
          ).name;
          this.confirmLoading = true;
          csp
            .createCustomer(data)
            .then(() => {
              this.form.resetFields();
              this.confirmLoading = false;
              this.$message.success(
                this.$t("page_user_management_new_success")
              );
              this.$emit("reload");
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        } else {
          this.confirmLoading = false;
        }
      });
    },
    async getCityList(value) {
      this.cityList = await (await rsp.select(value)).data;
    },
    async getRegionList() {
      return await (await rsp.selectByLevel()).data;
    },
    async getList() {
      let result = await crsp.list("CustomerObject");
      this.codeList = result.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    },
    handleSelectChange(val) {
      if (val) {
        this.form.setFieldsValue({ ["code"]: "" });
        //  console.log(11111,this.form.getFieldValue("code"))
        this.codeId = true;
      } else {
        this.codeId = false;
      }
    },
    async getAuthorityDomainList() {
      const { data } = await adsp.getEnableTreeList();
      const tree = tranformTreeShape(data[0]);
      tree.selectable = false;
      this.treeData = [tree];
    },
  },
};
</script>
<style scoped></style>
